<template>
    <div>
        <modal class="all-instead-landlord" :display="modalStatus.bizAllInsteadGroupAndSales" @modalStatus="closeModal" >
            <alarm-msg-white type="ERROR" :msg="alarm.error.msg" :count="alarm.error.count" :showAlarm="alarm.error.status" @timeOut="alarm.error.status=false"></alarm-msg-white>
            <h1>所有業務替換為</h1>
            <div class="all-instead-landlord-wrap">
                <div class="description">
                    您在列表勾選的房源都將替換為您下面所選的業務<br>（除了預定中的房源不可編輯外）
                </div>
                <div class="setting">
                    <div v-if="isAllGroup" class="block">
                        <label class="button-font input-label">
                            <div class="title">
                                業務分群
                            </div>
                            <span v-show="error.group" class="error-with-title">{{error.group}}</span>
                        </label>
                        <div class="input-arear">
                            <select-group :class="{error: error.group}" @getId="setGroupId" msg="請選擇區域"></select-group>
                        </div>
                    </div>
                    <div class="block">
                        <label class="button-font input-label">
                            <div class="title">
                                業務
                            </div>
                        </label>
                        <div class="input-arear">
                            <select-sales @click.native="checkOptionRules" @getId="setSalesId" msg="請選擇業務"></select-sales>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="setGroupAndSales">更新</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import alarmMsgWhite from '@/components/bussiness/widges/alarms/alarmMsgWhite.vue';
import selectGroup from '@/components/bussiness/widges/input/selectGroup.vue';
import selectSales from '@/components/bussiness/widges/input/selectSales.vue';
import { mapGetters } from 'vuex'

import { 
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            groupId: null,
            salesId: null,
            error: {
                group: null
            },
            alarm: {
                success:{
                    status: false,
                    msg: null,
                    count: 3000
                },
                error:{
                    status: false,
                    msg: null,
                    count: 3000
                }
            },
        }
    },
    mounted () {
        if(!this.isAllGroup){
            this.$store.dispatch('getBizDispatchMemberByGroupList', this.userGroupId)
            this.setGroupId(this.userGroupId)
        }
    },
    watch: {
        groupId: function (val) {
            if(val){
                this.error.group = null
            }
        }
    },
    methods: {
        setGroupAndSales: function () {
            if(this.groupId && this.error.group == null){
                this.$analyticsBiz.logEvent('所有業務替換為', { screen_name: '所有業務替換為'})
                this.$store.dispatch('updateBizBatchDispatchSales')
                .then(()=>{
                    this.closeModal()
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '成功替換業務',type: 'success'})
                })
            }else{
                this.alarm.error.msg = '尚未填寫完整'
                this.alarm.error.status = true
            }
        },
        setGroupId: function (value) {
            this.groupId = value
            this.$store.dispatch('setBizBatchDispatchInsteadGroupId', this.groupId)
        },
        setSalesId: function (value) {
            console.log(value)
            this.salesId = value
            this.$store.dispatch('setBizBatchDispatchInsteadSalesId', this.salesId)
        },
        checkOptionRules: function () {
            if(this.groupId == null){
                this.error.group = '請選擇業務分群'
            }
        },
        closeModal: function () {
            this.$store.dispatch('setBizBatchDispatchInsteadGroupId', null)
            this.$store.dispatch('setBizBatchDispatchInsteadSalesId', null)
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizAllInsteadGroupAndSales'})
        },
    },
    computed: {
        isOpen: function () {
            if(this.value){
                return '開啟'
            }else{
                return '關閉'
            }
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
            userGroupId: 'GET_BIZ_USER_GROUP_ID'
        })
    },
    components: {
        Modal,
        selectGroup,
        selectSales,
        alarmMsgWhite
    }
}
</script>
<style lang="scss">
    #modal.all-instead-landlord{
        .modal-content{
            width: 372px;
            padding: 0 !important;
            .detail{
                .alarm-msg{
                    left: 50%;
                    margin-left: -70px;
                }
                >h1{
                    margin-top: 32px;
                    margin-bottom: 16px;
                }
                .all-instead-landlord-wrap{
                    padding: 0 32px 0 32px;
                    .description{
                        font-weight: 300;
                        line-height: 1.57;
                        margin-bottom: 20px;
                        color: #676362;
                        text-align: center;
                    }
                    .setting{
                        margin-bottom: 36px;
                        .block{
                            margin-bottom: 24px;
                            .biz-rent-select-filter.select-item {
                                height: 44px;
                                .select-filter{
                                    width: 100%;
                                }
                                ul{
                                    width: 100%;
                                }
                            }
                        }
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 184px;
                    height: 44px;
                }
                button.confirm{
                    margin-right: 16px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/allInsteadGroupAndSales.vue